import React from 'react';
import DiscardChangesDialog from 'src/components/pedigree-chart/pedigree-sidebar/DiscardChangesDialog';
import { useAutoTranslation } from 'src/hooks/useTranslate';

/**
 * The "you have unsaved changes" confirmation shown when a clinical-record
 * modal is closed with edits pending.
 *
 * The disease, phenotype and genotype modals were the three that never asked
 * (TGCLOUD-1823) — a clinician could type an age, hit the X, and lose it
 * silently. Since TGCLOUD-1902 it is the same prompt every exit uses (the
 * sidebar's DiscardChangesDialog): "You have N unsaved changes. Discard them?",
 * with Keep editing the safe default (focused, and what Escape does).
 *
 * `onDiscard` must close the record for real. Every caller pairs it with a
 * reset, because these modals stay mounted after closing and would otherwise
 * show the discarded values again on the next open.
 *
 * @param {object} props
 * @param {number} [props.count]  how many fields hold a change
 */
export default function UnsavedChangesDialog({
  open,
  onCancel,
  onDiscard,
  count
}) {
  const t = useAutoTranslation();

  return (
    <DiscardChangesDialog
      open={open}
      onCancel={onCancel}
      onConfirm={onDiscard}
      count={Number.isFinite(count) && count > 0 ? count : undefined}
      cancelLabel={t('Keep editing')}
      confirmLabel={t('Discard changes')}
      ariaLabel={t('Confirm discarding unsaved changes')}
    >
      {Number.isFinite(count) && count > 0
        ? null
        : t('You have unsaved changes. Discard them?')}
    </DiscardChangesDialog>
  );
}
